import { get, post, put, destroy } from "presentation/utils/api";

//Define a rota base desse serviço
const baseRoute = "AcademicPeriods";


export const findAll = async () => {
    return await get(baseRoute);
};

export const findById = async (id) => {
    return await get(baseRoute, "/" + id);
};

export const findSchoolDaysCalendar = async (id) => {
    return await get(baseRoute, "/get_school_days_calendar/" + id);
};

export const add = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "", data);
};

export const update = async (postData) => {
    var data = JSON.stringify(postData);
    return await put(baseRoute, "", data);
};

export const save = async (postData) => {
    if (postData.id !== undefined) {
        return await update(postData);
    } else {
        return await add(postData);
    }
};

export const saveSchoolDays = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "save_school_days", data);
};

export const remove = async (id) => {
    return await destroy(baseRoute, "", id);
};


const academicPeriodsService = {
    findAll,
    findById,
    findSchoolDaysCalendar,
    add,
    update,
    save,
    saveSchoolDays,
    remove,
}

export default academicPeriodsService;